import { X } from "lucide-react";
import {
  StyledTableContainer,
  BoxComFaixa,
  FaixaTitulo,
  TableContainerEstiloExemplo,
  EmptyCell,
} from "./styles";

export interface CampoAlteracao {
  campo: string;
  antes: string;
  depois: string;
}

interface BlocoAlteracoesProps {
  campos: CampoAlteracao[];
  sectionTitle?: string;
  /** Quando true, exibe o título como faixa cinza acima da tabela (estilo demanda/nova parte) */
  tituloComoFaixa?: boolean;
}

export default function BlocoAlteracoes({ campos, sectionTitle = "Principal", tituloComoFaixa = false }: BlocoAlteracoesProps) {
  if (campos.length === 0) {
    return null;
  }

  const renderCell = (valor: string, isEmpty: boolean, tituloComoFaixaMode: boolean) => {
    if (valor !== '—') return valor;
    if (tituloComoFaixaMode) return <EmptyCell><X size={14} className="x-icon" aria-hidden /></EmptyCell>;
    return valor;
  };

  const tabelaPadrao = (
    <StyledTableContainer>
      <table className="data-table">
        <thead>
          <tr>
            <th className="field-col">Campo</th>
            <th className="before-col">Antes</th>
            <th className="after-col">Depois</th>
          </tr>
        </thead>
        <tbody>
          {campos.map((campo, i) => (
            <tr key={i} className={i > 0 ? 'border-top' : ''}>
              <td className="field-cell">{campo.campo}</td>
              <td className={`before-cell ${campo.antes === '—' ? 'empty-value' : ''}`}>
                {renderCell(campo.antes, campo.antes === '—', false)}
              </td>
              <td className={`after-cell ${campo.depois === '—' ? 'empty-value' : ''}`}>
                {renderCell(campo.depois, campo.depois === '—', false)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </StyledTableContainer>
  );

  const tabelaEstiloExemplo = (
    <TableContainerEstiloExemplo>
      <table className="data-table">
        <thead>
          <tr>
            <th className="field-col">Campo</th>
            <th className="before-col">Antes</th>
            <th className="after-col">Depois</th>
          </tr>
        </thead>
        <tbody>
          {campos.map((campo, i) => (
            <tr key={i} className={i > 0 ? 'border-top' : ''}>
              <td className="field-cell">{campo.campo}</td>
              <td className={`before-cell ${campo.antes === '—' ? 'empty-value' : ''}`}>
                {renderCell(campo.antes, campo.antes === '—', true)}
              </td>
              <td className={`after-cell ${campo.depois === '—' ? 'empty-value' : ''}`}>
                {renderCell(campo.depois, campo.depois === '—', true)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainerEstiloExemplo>
  );

  if (tituloComoFaixa) {
    return (
      <BoxComFaixa className="expanded-section">
        <FaixaTitulo>{sectionTitle}</FaixaTitulo>
        {tabelaEstiloExemplo}
      </BoxComFaixa>
    );
  }

  return (
    <div className="expanded-section">
      <h4 className="section-title">{sectionTitle}</h4>
      {tabelaPadrao}
    </div>
  );
}
